export const FEATURES_CONSTANTS = {
  title: "Key Benefits of OEM Converged Architecture",
  list: [
    {
      label: "Pre-Validated and Integrated Solutions",
      text: "Ensures compatibility between OEM components, reducing deployment time and complexity.",
    },
    {
      label: "Cloud-Optimized Infrastructure",
      text: "Supports integration with multi-cloud and hybrid cloud environments, enabling businesses to leverage cloud computing benefits.",
    },
    {
      label: "Software-Defined Management",
      text: "Centralized management and automation tools streamline IT operations.",
    },
    {
      label: "Scalability and Flexibility",
      text: "Easily expand storage, compute, and networking resources as business needs evolve.",
    },
    {
      label: "High Availability and Disaster Recovery",
      text: "Built-in failover mechanisms ensure business continuity and minimal downtime.",
    },
    {
      label: "Enhanced Security and Compliance",
      text: "Enforces zero-trust architecture, encryption, and access controls across all OEM systems.",
    },
  ],
};
